'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
const TemplateNotFound = () => {
  return /*#__PURE__*/_jsx(Section, {
    use: "island",
    children: /*#__PURE__*/_jsx(TFlex, {
      justify: "around",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        illustration: "errors/map",
        title: I18n.text('reports.analysis.templateNotFound.title'),
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(UIRouterLink, {
            to: "/",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reports.analysis.permissionRequired.goBack"
            })
          })
        })
      })
    })
  });
};
export default TemplateNotFound;